function encodeText(text) {
    let arr = text.replace(/#W/g, "").replace(/#w\(\d\)/g, '').replace(/#([dw])\((-?\d+)\)/g, '').split('#r').filter(item => item.trim() !== '')
    let arr2 = []
    arr.forEach(item => {
        let res = []
        let continueCount = 0
        let text = ''
        let divClass = ''
        let textColor = ""
        let divType = ''
        // 基本都是div,只有图片这个需要特殊处理

        for (let i = 0; i < item.length; i++) {
            if (continueCount > 0) {
                continueCount -= 1
                continue
            }
            if (item[i] == " ") {
                if (text) {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    text = ""
                    textColor = ""
                    divClass = ""
                    res.push({
                        'text': "",
                        'data': {
                            'class': "",
                            'style': {
                                'color': ""
                            }
                        },
                        'divType': "empty"
                    })
                } else {
                    res.push({
                        'text': "",
                        'data': {
                            'class': "",
                            'style': {
                                'color': ""
                            }
                        },
                        'divType': "empty"
                    })
                }
                continue
            }

            if (item[i] == '#' && item[i + 1] != '#') {
                if (item[i + 1] == 'c') {
                    // 先把前面的变成一个
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            },
                        },
                        'divType': divType
                    })
                    text = ''
                    divClass = ''
                    textColor = ''
                    divType = ''
                    continueCount = 7
                    textColor = '#' + item.slice(i + 2, i + 8)
                } else if (item[i + 1] == "G") {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    continueCount = 1
                    divClass = 'green'
                    text = ""
                    textColor = ""
                } else if (item[i + 1] == 'R') {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    continueCount = 1
                    divClass = 'red'
                    text = ""
                    textColor = ""
                } else if (item[i + 1] == 'B') {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    continueCount = 1
                    divClass = 'blue'
                    text = " "
                    textColor = ""
                } else if (item[i + 1] == 'Y') {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    continueCount = 1
                    divClass = 'yellow'
                    text = ""
                    textColor = ""
                } else if (item[i + 1] == 'K') {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    continueCount = 1
                    divClass = 'black'
                    text = ""
                    textColor = ""
                } else if (item[i + 1] == 'P') {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    continueCount = 1
                    divClass = 'purple'
                    text = ""
                    textColor = ""
                } else if (item[i + 1] == 'O') {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    continueCount = 1
                    divClass = 'orange'
                    text = ""
                    textColor = ""
                } else if (item[i + 1] == 'Q') {
                    res.push({
                        'text': text,
                        'data': {
                            'class': divClass,
                            'style': {
                                'color': textColor
                            }
                        },
                        'divType': ""
                    })
                    continueCount = 1
                    divClass = 'light_blue'
                    text = ""
                    textColor = ""
                }
            } else if (item[i] == '#' && item[i + 1] == '#') {
                text += '#'
            } else if (item.includes('^')) {
                let startIndex = item.indexOf('^')
                let text1 = item.slice(0, startIndex)
                let text2 = item.slice(startIndex)
                res.push({
                    'text': text1,
                    'data': {
                        'class': "",
                        'style': {
                            'color': ""
                        }
                    },
                    'divType': ""
                })
                let imgArr = text2.split('^')
                imgArr.forEach((item) => {
                    if (parseInt(item)) {
                        res.push({
                            'text': '',
                            'data': {
                                'src': item
                            },
                            'divType': "img"
                        })
                    }
                })
                break
            }
            else {
                text += item[i]
            }
        }
        res.push({
            'text': text,
            'data': {
                'class': divClass,
                'style': {
                    'color': textColor
                }
            },
            'divType': divType
        })
        arr2.push(res)
    });
    return arr2
}

export default encodeText
